import {Container, Nav, Navbar} from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const location = useLocation();
  const [scrolling, setScrolling] = useState(false);
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(true);
  const api_baseurl = process.env.REACT_APP_API_BASE_URL;
  const img_baseurl = process.env.REACT_APP_IMAGES_BASE_URL;
  const fetchHomeMenu =async() => {
    try {
      const response = await fetch(`${api_baseurl}get-top-menu.php`);
      const result = await response.json();
      setMenu(result.data); // Adjust based on your API response  
      setLoading(false);         
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);   
    } finally {}
  };

  const handleScroll = () => {
    if (window.scrollY > 0) {
        setScrolling(true);
    } else {
        setScrolling(false);
    }
  };   

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);  
    fetchHomeMenu();  
    return()=>{      
      window.removeEventListener("scroll", handleScroll);
    }
  }, []);
  return (
    <>
      {
        loading ? (
          <div className="animate-pulse bg-slate-500 w-full" style={{height:"77px"}}>
            <div className="flex justify-between items-center ps-5 h-full container">
                <div className="h-16 bg-slate-300 rounded w-60"></div>
                <div className="flex justify-between items-center pe-5 h-full m-0 w-2/5">
                    <div className="h-6 rounded bg-slate-300 w-1/5 mx-2"></div>
                    <div className="h-6 rounded bg-slate-300 w-1/5 mx-2"></div>
                    <div className="h-6 rounded bg-slate-300 w-1/5 mx-2"></div>
                    <div className="h-6 rounded bg-slate-300 w-1/5 mx-2"></div>
                    <div className="h-6 rounded bg-slate-300 w-1/5 mx-2"></div>
                </div>
              </div>
          </div>          
        ):(
          <Navbar expand="lg" sticky="top" className={scrolling ? "bg-gray-900" : "bg-transparent"}>
            <Container>
              <Navbar.Brand href="./">
                <img loading="lazy" src={`${img_baseurl}images/logo.png`} alt='logo' className='img-fluid' style={{width:"20%"}}/>
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ms-auto">
                  {
                    menu.map((menuItem) =>
                      <Link  key={menuItem.url} to={`./${menuItem.url}`} className={`${location.pathname === `/${menuItem.url}` ? "!text-yellow-400" : "text-white"} text-uppercase fw-semibold fs-13 text-nowrap nav-link`}>{menuItem.menu_name}</Link>
                    )
                  }
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        )
      }
    </>
  );
}